(function () {
  'use strict';
  var DOC = document;
  var HTML = DOC.documentElement;

  // --- Optional config ---
  // If you need to blur a specific container instead of the whole body, set this:
  // e.g., var BLUR_SCOPE_SELECTOR = '.page-wrapper';
  var BLUR_SCOPE_SELECTOR = '';

  // Keep a single MutationObserver instance so we can reconnect it after bfcache restores
  var mo = null;

  // Debounce utility to avoid thrashing on quick events
  function debounce(fn, delay) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, delay);
    };
  }

  function ensureOverlay() {
    if (!DOC.getElementById('cookie-blur-overlay')) {
      var ov = DOC.createElement('div');
      ov.id = 'cookie-blur-overlay';
      if (DOC.body) {
        DOC.body.appendChild(ov);
      } else {
        DOC.addEventListener('DOMContentLoaded', function () {
          if (!DOC.getElementById('cookie-blur-overlay')) {
            DOC.body.appendChild(ov);
          }
        });
      }
    }
  }

  function isVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return parseFloat(style.opacity || '1') > 0.01;
  }

  function isConsentUiOpen() {
    var banner = DOC.getElementById('onetrust-banner-sdk');
    var pc = DOC.getElementById('onetrust-pc-sdk');
    return (
      isVisible(banner) ||
      isVisible(pc) ||
      HTML.classList.contains('ot-fade-in') ||
      HTML.classList.contains('ot-pc-open') ||
      (DOC.body && DOC.body.classList.contains('ot-open-modal'))
    );
  }

  function setBlurState(active) {
    ensureOverlay();
    HTML.classList.toggle('cookie-blur--active', !!active);

    if (BLUR_SCOPE_SELECTOR) {
      var scope = DOC.querySelector(BLUR_SCOPE_SELECTOR);
      if (scope) {
        scope.classList.toggle('cookie-blur-scope--active', !!active);
      }
    }
  }

  // Attach (or reattach) observers to current OneTrust nodes
  function attachObservers() {
    var targets = [
      DOC.getElementById('onetrust-banner-sdk'),
      DOC.getElementById('onetrust-pc-sdk'),
      DOC.body
    ].filter(Boolean);

    // If nodes not present yet, retry shortly (handles late OneTrust mount)
    if (!targets.length) {
      setTimeout(attachObservers, 150);
      return;
    }

    // Disconnect existing observer before re-creating
    if (mo) {
      try { mo.disconnect(); } catch (e) { /* no-op */ }
    }

    mo = new MutationObserver(function () {
      setBlurState(isConsentUiOpen());
    });

    targets.forEach(function (t) {
      try {
        mo.observe(t, { attributes: true, attributeFilter: ['style', 'class'] });
      } catch (e) { /* no-op */ }
    });

    // Wire up OneTrust control buttons (accept/reject/open/save/close)
    [
      '#onetrust-accept-btn-handler',
      '#onetrust-reject-all-handler',
      '#onetrust-pc-btn-handler',
      '#accept-recommended-btn-handler',
      '#save-preference-btn-handler',
      '.ot-pc-refuse-all-handler',
      '.ot-pc-save-handler',
      '.ot-close-icon'
    ].forEach(function (sel) {
      var btn = DOC.querySelector(sel);
      if (btn && !btn._cookieBlurBound) {
        btn._cookieBlurBound = true;
        btn.addEventListener('click', function () {
          // Allow OneTrust to mutate DOM first, then update blur
          setTimeout(function () { setBlurState(isConsentUiOpen()); }, 60);
        });
      }
    });

    // Initial sync (small delay to allow any initial OT transition)
    setTimeout(function () { setBlurState(isConsentUiOpen()); }, 100);
  }

  // Explicit recompute + ensure observers are attached
  var recompute = debounce(function () {
    try { attachObservers(); } catch (e) { /* no-op */ }
    setBlurState(isConsentUiOpen());
  }, 50);

  // Compose with existing OptanonWrapper hook
  var existingOW = window.OptanonWrapper;
  window.OptanonWrapper = function () {
    try { attachObservers(); } catch (e) { /* no-op */ }
    if (typeof existingOW === 'function') {
      try { existingOW(); } catch (e) { /* no-op */ }
    }
  };

  // Fallbacks for different load orders
  if (typeof window.OnetrustActiveGroups !== 'undefined') {
    try { attachObservers(); } catch (e) { /* no-op */ }
  }

  // Initial DOM-ready sync
  if (DOC.readyState === 'loading') {
    DOC.addEventListener('DOMContentLoaded', function () {
      setTimeout(function () { setBlurState(isConsentUiOpen()); }, 120);
    });
  } else {
    setTimeout(function () { setBlurState(isConsentUiOpen()); }, 120);
  }

  // -----------------------------
  // bfcache / history navigation
  // -----------------------------

  // Fired on back/forward cache restores (e.persisted === true),
  // and also on normal navigations.
  window.addEventListener('pageshow', function (e) {
    // Reattach observers and recompute regardless; bfcache or not
    // (Some browsers don't set persisted for cross-origin hops)
    setTimeout(recompute, e && e.persisted ? 10 : 0);
  });

  // History API navigation (single-page-ish themes or filters)
  window.addEventListener('popstate', function () {
    setTimeout(recompute, 0);
  });

  // Hash changes can toggle in-page states
  window.addEventListener('hashchange', function () {
    setTimeout(recompute, 0);
  });

  // When the tab becomes visible again after being cached/hidden
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      setTimeout(recompute, 0);
    }
  });

  // Optional: some themes/apps dispatch custom events on partial reloads
  // Recompute on common Shopify events if present
  window.addEventListener('shopify:section:load', recompute);
  window.addEventListener('shopify:section:select', recompute);
  window.addEventListener('shopify:section:deselect', recompute);
  window.addEventListener('shopify:block:select', recompute);
  window.addEventListener('shopify:block:deselect', recompute);

  // If using BLUR_SCOPE_SELECTOR (e.g., '.page-wrapper'):
  // Replace "html.cookie-blur--active body" with
  // "html.cookie-blur--active .page-wrapper" and set BLUR_SCOPE_SELECTOR above.


})();
